let legacyCounter = 0;

function nextLegacySuffix(): string {
	legacyCounter = (legacyCounter + 1) % Number.MAX_SAFE_INTEGER;
	return legacyCounter.toString(36);
}

function generateLegacyId(): string {
	const now = Date.now().toString(36);
	const random = Math.random().toString(36).slice(2, 10);
	return `${now}-${random}-${nextLegacySuffix()}`;
}

function generateUuid(): string {
	const cryptoRef = globalThis.crypto;
	if (cryptoRef?.randomUUID) {
		return cryptoRef.randomUUID();
	}
	if (cryptoRef?.getRandomValues) {
		const buf = new Uint32Array(4);
		cryptoRef.getRandomValues(buf);
		return Array.from(buf, (v) => v.toString(16).padStart(8, "0")).join("-");
	}
	return generateLegacyId();
}

export function createUploadFileId(
	fieldId: string,
	serverProvidedId?: string | null,
): string {
	const trimmed = serverProvidedId?.trim();
	if (trimmed) {
		return trimmed;
	}
	const sanitizedField = fieldId.trim().replace(/\s+/g, "-");
	return `${sanitizedField}_${generateUuid()}`;
}

// Exposed for tests to reset deterministic state
export function __resetLegacyCounter(): void {
	legacyCounter = 0;
}
